module.exports = __webpack_public_path__ + "04_face.5b2454aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer1/04_face.png
// module id = Dvap
// module chunks = 0